export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-20 pb-12 md:pb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full">
        <div className="grid md:grid-cols-5 gap-8 md:gap-12 items-center">
          <div className="md:col-span-2 space-y-6 md:space-y-8 text-center md:text-left">
            <div className="inline-block bg-[#EDE9FE] text-[#8B5CF6] px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap">
              NO.1 퀸알바 플랫폼
            </div>
            
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#1A2332] leading-tight">
              퀸알바의
              <br />
              선택은
              <br />
              <span className="inline-flex items-center gap-2 md:gap-3 justify-center md:justify-start">
                온니잡에서!
                <span className="inline-flex w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden border-4 border-white shadow-lg">
                  <img
                    src="https://public.readdy.ai/ai/img_res/d5e6bfaf9474fbb29256397c228b6edd.jpg"
                    alt="사용자"
                    className="w-full h-full object-cover"
                  />
                </span>
              </span>
            </h1>

            <p className="text-base md:text-lg text-gray-600 leading-relaxed px-4 md:px-0">
              검증된 업체, 안전한 근무환경, 빠른 급여 지급까지. 당신의 성공적인 아르바이트를 온니잡이 책임집니다.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center md:justify-start">
              <a 
                href="https://apps.apple.com/kr/app/%EC%98%A8%EB%8B%88%EC%9E%A1-%EC%9D%B5%EB%AA%85-%EC%97%AC%EC%84%B1-%EC%BB%A4%EB%AE%A4%EB%8B%88%ED%8B%B0-%EC%95%8C%EB%B0%94/id6745007770" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-[#8B5CF6] text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold hover:bg-[#7C3AED] transition-all hover:shadow-lg whitespace-nowrap text-center"
              >
                무료로 시작하기
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=kr.onnyjob.app&hl=ko" 
                target="_blank" 
                rel="noopener noreferrer"
                className="border-2 border-[#1A2332] text-[#1A2332] px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold hover:bg-[#1A2332] hover:text-white transition-all whitespace-nowrap text-center"
              >
                서비스 둘러보기
              </a>
            </div>
          </div>

          <div className="md:col-span-3 relative mt-8 md:mt-0">
            <div className="relative bg-gradient-to-br from-[#EDE9FE] via-[#DDD6FE] to-[#C4B5FD] rounded-3xl p-6 sm:p-8 md:p-12 min-h-[400px] sm:min-h-[500px] md:min-h-[600px] flex items-center justify-center">
              <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-black/0 to-black/5 rounded-3xl"></div>
              
              <div className="relative transform rotate-3 md:rotate-6 hover:rotate-0 md:hover:rotate-3 transition-transform duration-500">
                <img
                  src="https://static.readdy.ai/image/5e8897340d9d3c287a609e9913af4db2/908f256476a1634cfd856e51020e1094.jpeg"
                  alt="온니잡 앱"
                  className="w-48 sm:w-60 md:w-80 h-auto rounded-3xl shadow-2xl"
                />
              </div>

              <div className="absolute top-4 sm:top-10 md:top-20 left-2 sm:left-6 md:left-10 bg-white px-3 sm:px-4 md:px-6 py-2 md:py-3 rounded-full shadow-lg animate-bounce">
                <div className="flex items-center gap-1 sm:gap-2">
                  <span className="text-lg sm:text-xl md:text-2xl">⭐</span>
                  <span className="font-bold text-[#1A2332] text-xs sm:text-sm md:text-base">98% 만족도</span>
                </div>
              </div>

              <div className="absolute bottom-16 sm:bottom-24 md:bottom-32 right-2 sm:right-6 md:right-10 bg-white px-3 sm:px-4 md:px-6 py-2 md:py-3 rounded-full shadow-lg">
                <div className="flex items-center gap-1 sm:gap-2">
                  <span className="text-lg sm:text-xl md:text-2xl">💰</span>
                  <span className="font-bold text-[#1A2332] text-xs sm:text-sm md:text-base">평균 시급 150,000원</span>
                </div>
              </div>

              <div className="absolute top-1/2 -right-2 sm:right-0 bg-[#8B5CF6] text-white px-3 sm:px-4 md:px-6 py-2 md:py-3 rounded-full shadow-lg">
                <span className="font-bold whitespace-nowrap text-xs sm:text-sm md:text-base">빠른 급여 지급</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
